import { render, staticRenderFns } from "./invenOrderDetails.vue?vue&type=template&id=1aa9d4e8&scoped=true&"
import script from "./invenOrderDetails.vue?vue&type=script&lang=js&"
export * from "./invenOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./invenOrderDetails.vue?vue&type=style&index=0&id=1aa9d4e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9d4e8",
  null
  
)

component.options.__file = "invenOrderDetails.vue"
export default component.exports